import { postDocumentCompleteTask } from '@zurich/api/document';
import { useFetchApi, useTranslation } from '@zurich/common/hooks';
export function usePostDocumentComplete() {
    const { t } = useTranslation();
    const { fetchApi } = useFetchApi();
    const handleFetch = async ({ taskId, body }) => {
        const response = await fetchApi(postDocumentCompleteTask, {
            vars: {
                taskId,
            },
            body,
        }, {
            errorText: t('party:document.errors.uploadDocument'),
        });
        return response;
    };
    return handleFetch;
}
